export function normalizeSnowflakeId(value) {
  if (value == null || value === '') return ''
  if (typeof value === 'bigint') return value.toString()
  if (typeof value === 'string') return value.trim()
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return ''
    if (!Number.isSafeInteger(value)) return ''
    return String(Math.trunc(value))
  }
  return String(value).trim()
}

export function coerceSnowflakeString(value) {
  const n = normalizeSnowflakeId(value)
  if (n) return n
  if (typeof value === 'string') {
    const s = value.trim()
    if (/^\d{10,}$/.test(s)) return s
    return s
  }
  return ''
}

export function normalizeSchemeDialogueMessage(row, currentUserId = '') {
  if (!row) return null

  const seqRaw = row.seqNum
  const seqNum =
    seqRaw != null && seqRaw !== ''
      ? Number(seqRaw)
      : 0

  const msgType = String(row.msgType || row.type || 'TEXT').toUpperCase()
  const rawContent = row.content != null ? String(row.content) : ''
  let attachment = null
  if (msgType !== 'TEXT' && rawContent) {
    try {
      const parsed = JSON.parse(rawContent)
      if (parsed && (parsed.url || parsed.httpFilePath || parsed.httpFileUrl)) {
        attachment = {
          url: parsed.url || parsed.httpFilePath || parsed.httpFileUrl || '',
          name: parsed.name || parsed.fileName || '',
          size: parsed.size || parsed.fileSize || 0
        }
      }
    } catch (e) {
      // 兼容：部分历史数据可能直接把 url 存在 content
      if (/^https?:\/\//i.test(rawContent)) {
        attachment = { url: rawContent, name: '', size: 0 }
      }
    }
  }

  const senderUserId = normalizeSnowflakeId(
    row.senderUserId != null ? row.senderUserId : row.fromUserId
  )
  const normalizedCurrentUserId = normalizeSnowflakeId(currentUserId)
  const fromMeByUser = !!(
    normalizedCurrentUserId &&
    senderUserId &&
    senderUserId === normalizedCurrentUserId
  )
  const fromMeByFlag = row.fromMe === true || String(row.fromMe).toLowerCase() === 'true'
  const from = senderUserId ? (fromMeByUser ? 'me' : 'other') : fromMeByFlag ? 'me' : 'other'

  return {
    id: row.id != null && row.id !== '' ? String(row.id) : '',
    conversationId: row.conversationId != null && row.conversationId !== '' ? String(row.conversationId) : '',
    seqNum: Number.isFinite(seqNum) ? seqNum : 0,
    msgType,
    text: msgType === 'TEXT' || msgType === 'SYSTEM' ? rawContent : '',
    attachment,
    creationDate: row.creationDate || '',
    from,
    raw: row
  }
}

export function normalizeSchemeDialogueSession(item, chatKind, conversation) {
  if (!item) return null

  const receiverUserId =
    item.receiverUserId ||
    item.userId ||
    item.contactId ||
    item.targetUserId ||
    ''
  const receiverName =
    item.receiverName ||
    item.contactName ||
    item.name ||
    item.title ||
    item.typeLabel ||
    '未命名联系人'
  const title =
    receiverName
  const subtitleParts = []

  if (item.company) subtitleParts.push(item.company)
  if (item.industry) subtitleParts.push(item.industry)
  if (item.typeLabel) subtitleParts.push(item.typeLabel)

  return {
    id: `${chatKind}-${item.entityId || item.id}`,
    entityId: item.entityId || item.id || '',
    chatKind,
    name: title,
    subtitle: subtitleParts.join(' · ') || '待补充',
    senderUserId: normalizeSnowflakeId(conversation?.senderUserId || item.senderUserId || ''),
    senderName: conversation?.senderName || item.senderName || '',
    receiverUserId: normalizeSnowflakeId(
      conversation?.receiverUserId || String(receiverUserId || '')
    ),
    receiverName: conversation?.receiverName || receiverName,
    conversationId: conversation && conversation.id ? conversation.id : '',
    unreadCount: conversation && conversation.unreadCount != null ? conversation.unreadCount : 0,
    lastMessagePreview: conversation && conversation.lastMessagePreview ? conversation.lastMessagePreview : '',
    source: item,
    messages: []
  }
}
